<template>
  <div class="ui modal zw transitionstyle" :class="tabs.length > 6 ? 'fullscreen' : 'large'" v-cloak
       v-if="selectedBooking">
    <div class="ui seven top attached zw small steps" v-cloak>
      <div class="step" v-for="(tab, index) in tabs" :key="index" @click="switchTab(index)"
           :class="{ 'active' : currentTab === index }" :id="tab.name">
        <i class="icon" :class="tab.icon"/>
        <div class="content">
          <div class="title">{{ tab.title }}</div>
          <div class="description">{{ tab.description }}</div>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'product'">
      <div class="content">
        <h3 class="ui header">
          {{ selectedBooking.product.name }}
          <div class="ui sub header" v-html="selectedBooking.product.intro"></div>
        </h3>
        <div class="ui divider"></div>
        <h4 class="ui header">{{ $t('modals.newbookingmodal.product.content.description') }}</h4>
        <div class="description" v-html="selectedBooking.product.description"></div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'time'">
      <div class="content">
        <div class="ui two column stackable grid">
          <div class="eight wide column zw">
            <flat-pickr ref="flatpicker" v-model="booking.selectedDate" :config="booking.flatPickr.config"
                        :events="['onMonthChange', 'onYearChange', 'onChange', 'onReady']"
                        @on-month-change="fetchDates" @on-year-change="fetchDates" @on-change="fetchTimes"
                        @on-ready="fetchDates"></flat-pickr>
          </div>
          <div class="eight wide column">
            <div class="ui segment zw-fluid">
              <div class="ui divided pickable segments" v-if="booking.selectableTimes.length">
                <div class="ui zw center aligned segment"
                     :class="{ 'selected' : booking.selectedStartTime === time.startTime && booking.selectedEndTime === time.endTime, 'disabled': booking.selectedStartTime === time.startTime && booking.selectedEndTime === time.endTime && !isTimeAvailable }"
                     v-for="(time, index) in booking.selectableTimes" :key="index"
                     @click="selectTime(time.startTime, time.endTime)">
                  <h2 class="zw compact header">{{ time.startTime }} - {{ time.endTime }}</h2>
                  <div class="zw selection icon" v-if="isTimeAvailable"><i class="checkmark icon"></i></div>
                  <div class="zw selection icon disabled" v-else><i class="close icon"></i></div>
                </div>
              </div>
              <div class="ui inverted dimmer active" v-else>
                <div class="content">
                  <div class="center">
                    <h2 class="ui icon header">
                      <i class="wait icon"></i>
                      {{ $t('modals.newbookingmodal.time.content.no_time') }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui grid"
             v-if="selectedBooking.multiple && booking.selectedStartTime !== null && booking.selectedEndTime !== null && !isTimeAvailable">
          <span class="ui header" style="color: red;">{{ $t('modals.newbookingmodal.time.no_available_slots') }}</span>
        </div>
        <div class="ui grid"
             v-if="selectedBooking.multiple && booking.selectedStartTime !== null && booking.selectedEndTime !== null && isTimeAvailable">
          <span class="ui header" style="color: #2ecc71;">{{
              $t('modals.newbookingmodal.time.available_slots', {amount: availableSlots})
            }}</span>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'winter_place'">
      <div class="content">
        <div v-if="!selectedWinterPlace && !existingWinterPlace">
          <h3 class="ui header">
            {{ $t('modals.newbookingmodal.winter_place.title_not_chosen') }}
          </h3>
        </div>
        <div v-else-if="existingWinterPlace">
          <div class="ui three column stackable grid center aligned">
            <div class="twelve wide tablet ten wide computer column">
              <div class="ui segments">
                <div class="ui zw-orange inverted center aligned segment">
                  <div class="ui huge header">{{ $t('modals.newbookingmodal.winter_place.existing_place.title') }}</div>
                </div>
                <div class="ui center aligned segment">
                  <div class="ui header">
                    {{ $t('modals.newbookingmodal.winter_place.existing_place.text1', {existingWinterPlace: existingWinterPlace}) }} <br>
                    {{ $t('modals.newbookingmodal.winter_place.existing_place.text2') }}
                  </div>
                </div>
                <div class="ui center aligned segment">
                  <input ref="overwriteCheckbox" v-model="overwritePlace" type="checkbox" @click="handleCheckboxClick($event)">
                  <label>{{ $t('modals.newbookingmodal.winter_place.existing_place.overwrite_checkbox.label') }}</label>

                  <modal :active="showOverwritePlaceConfirmModal" title="Confirmation window"
                         @denymodal="denyOverwritePlace" @acceptmodal="acceptOverwritePlace">
                    <h4>{{ $t('modals.newbookingmodal.winter_place.existing_place.overwrite_checkbox.modal_text', {existingWinterPlace: existingWinterPlace}) }}</h4>
                  </modal>
                </div>
                <div class="ui center aligned segment" v-if="selectedWinterPlace">
                  <div class="ui header">
                    {{ $t('modals.newbookingmodal.winter_place.existing_place.bottom_text') }}: {{ selectedWinterPlace }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h3>{{ $t('modals.newbookingmodal.winter_place.title_chosen', {place: selectedWinterPlace}) }}</h3>
        </div>
        <div class="ui divider"></div>
        <div class="ui">
          <div class="ui header">
            {{ $t('modals.newbookingmodal.winter_place.click_to_open') }}
          </div>
          <button @click="$emit('open-image', { winterPlace: selectedWinterPlace })" class="ui primary button">
            {{ $t('modals.newbookingmodal.winter_place.open_image') }}
          </button>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-show="tabs[currentTab].name === 'details'" v-if="selectedBooking">
      <div class="content">
        <div class="ui header">{{ $t('modals.newbookingmodal.details.content.header') }}</div>
        <div class="ui divider"></div>

        <div class="ui form" :data-vv-scope="details.formScope" v-cloak>
          <div class="two fields" :key="index"
               v-for="(fields, index) in chunkProperty(selectedBooking.product.fields, 2)"
               v-if="selectedBooking.product.fields">
            <field :field="field" :allowEdit="field.editable" :scope="details.formScope"
                   :metas="safeObjectGet(updateBooking, 'metas')" :winter-place="winterPlaceMeta" :transparent="false"
                   v-if="field"
                   @input="changeFieldValue" :value="details.fieldValues" v-for="field in fields"
                   :key="field.id">
            </field>
          </div>

          <div v-if="selectedBooking.guest_enabled || hasGuest">
            <div class="guest-option" :class="{
              'guest-option--selected': hasGuest,
              'guest-option--locked': isGuestOptionLocked,
              'guest-option--unavailable': guestCapacityUnavailable && !hasGuest
            }">
              <div class="guest-option__content">
                <div class="guest-option__icon">
                  <i class="users icon"></i>
                </div>
                <div class="guest-option__details">
                  <div class="guest-option__title">{{ $t('modals.newbookingmodal.guest.title') }}</div>
                  <p>{{ $t('modals.newbookingmodal.guest.description') }}</p>
                  <div class="guest-option__price">
                    <span>
                      {{ $t('modals.newbookingmodal.guest.sauna_price') }}:
                      <strong>{{ guestProductPrice | money }}</strong>
                    </span>
                    <span>+</span>
                    <span>
                      {{ $t('modals.newbookingmodal.guest.fee') }}:
                      <strong>{{ configuredGuestFee | money }}</strong>
                    </span>
                    <span class="guest-option__price-total">
                      ({{ $t('modals.newbookingmodal.guest.additional_cost') }}:
                      <strong>{{ guestOptionPrice | money }}</strong>)
                    </span>
                  </div>
                </div>
                <div class="ui toggle checkbox guest-option__checkbox">
                  <input type="checkbox" :checked="hasGuest" :disabled="!canEditGuest" @change="changeGuestValue($event)">
                  <label>{{ $t('modals.newbookingmodal.guest.label') }}</label>
                </div>
              </div>
              <p class="guest-option__locked-message" v-if="isGuestOptionLocked">
                <i class="lock icon"></i>
                {{ $t('modals.newbookingmodal.guest.locked') }}
              </p>
              <p class="guest-option__capacity-message" v-else-if="guestCapacityUnavailable">
                <i class="warning sign icon"></i>
                {{ $t('modals.newbookingmodal.guest.capacity_unavailable') }}
              </p>
            </div>
          </div>

          <div class="field" :class="{ 'error' : errors.has(details.formScope + '.terms') }">
            <div class="ui checkbox" id="termsbox">
              <input name="terms" :data-vv-as="$t('modals.newsubscriptionmodal.details.terms')"
                     :checked="details.acceptingTerms" type="checkbox" @change="changeTermsValue()"
                     :data-vv-scope="details.formScope" v-validate="'required'">
              <label>{{ $t('modals.newsubscriptionmodal.details.agree_to') }} <a
                @click.prevent="details.showTermsModal = !details.showTermsModal">{{
                  $t('modals.newsubscriptionmodal.details.terms')
                }}</a></label>
              <span style="color: red;" v-if="errors.has(details.formScope + '.terms')">{{
                  errors.first(details.formScope + '.terms')
                }}</span>
            </div>
          </div>

          <div class="two fields">
            <field allowEdit :scope="details.formScope" :field="subscriptionField" @fake-input="changeSubscription"
                   multiple :settings="{maxSelections: maxSubscriptionsSelect}"
                   :is-sub-field-valid="isSubscriptionValueValid" :are-all-subs-chosen="areAllSubscriptionsChosen"
                   :placeholder="'Select subscription(s)'">
              <template v-slot:subMessage
                        v-if="!safeObjectGet(selectedBooking, 'hasFreeBooked') && !safeObjectGet(updateBooking, 'is_free') && totalBookedFeePrice > 0">
                <span style="color: red;">Selected subscriptions will increase the cost of booking by {{
                    totalBookedFeePrice | money
                  }}</span>
              </template>
            </field>
          </div>
        </div>
      </div>

      <semantic-modal v-model="details.showTermsModal"
                      :settings="{content_classes: {content: true}, closeable: false, closeable_button: false}">
        <div class="ui header" slot="header">
          {{ $t('modals.paymentterms.header') }}
        </div>
        <payment-terms/>
        <div class="actions" slot="actions">
          <div class="ui deny red button" @click="denyTerms()">{{ $t('globals.buttons.no') }}</div>
          <div class="ui ok green button" @click="acceptTerms()">{{ $t('globals.buttons.accept') }}</div>
        </div>
      </semantic-modal>
    </div>

    <div class="ui active basic tab segment" v-show="tabs[currentTab].name === 'warning_message'"
         v-if="selectedBooking">
      <div class="content">
        <h3 class="ui header">{{ this.$t('modals.newbookingmodal.warning_message.content.header') }}</h3>
        <div class="ui divider"></div>
        <h4 class="ui header red">{{ selectedBooking.warning_message }}</h4>
        <div class="ui form" :data-vv-scope="warningMessage.formScope" v-cloak>
          <div class="field" :class="{ 'error' : errors.has(warningMessage.formScope + '.warning') }">
            <div class="ui checkbox">
              <input name="warning" :data-vv-as="this.$t('modals.newbookingmodal.warning_message.title')"
                     :checked="warningMessage.acceptingTerms" type="checkbox" @change="changeWarningAcceptValue()"
                     :data-vv-scope="warningMessage.formScope" v-validate="'required'">
              <label>{{ this.$t('modals.newbookingmodal.warning_message.content.agree') }}</label>
              <span style="color: red;" v-if="errors.has(warningMessage.formScope + '.warning')">{{
                  errors.first(warningMessage.formScope + '.warning')
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'confirm'">
      <div class="content">
        <div class="ui header"><i class="calendar icon"></i> {{
            $t('modals.newbookingmodal.confirm.content.header')
          }}
        </div>
        <div class="ui divider"></div>

        <div class="ui three column stackable grid">
          <div class="two wide tablet four wide computer column"></div>
          <div class="twelve wide tablet eight wide computer column">
            <div class="ui segments">
              <div class="ui zw-orange inverted center aligned segment">
                <div class="ui huge header">
                  {{ selectedBooking.product.name }}
                </div>
              </div>
              <div class="ui segment">
                <div class="ui two column stackable middle aligned divided grid">
                  <div class="row">
                    <div class="center aligned column">
                      <div class="ui zw statistic">
                        <h1 class="zw compact header" v-if="booking.selectedDate">
                          {{ formatDate(booking.selectedDate, 'DD') }}
                        </h1>
                        <div class="orange label" v-if="booking.selectedDate">
                          {{ formatDate(booking.selectedDate, 'MMMM') }}
                        </div>
                        <h1 class="zw compact header" v-else>
                          {{
                            $t('modals.newbookingmodal.confirm.content.validation.no_date_picked')
                          }}
                        </h1>
                      </div>
                      <template v-if="update">
                        <span class="text-center">-</span>
                        <div class="ui zw statistic">
                          <h1 class="zw compact header" v-if="booking.selectedEndDate">
                            {{ formatDate(booking.selectedEndDate, 'DD') }}
                          </h1>
                          <div class="orange label" v-if="booking.selectedDate">
                            {{ formatDate(booking.selectedEndDate, 'MMMM') }}
                          </div>
                          <h1 class="zw compact header" v-else>
                            {{
                              $t('modals.newbookingmodal.confirm.content.validation.no_date_picked')
                            }}
                          </h1>
                        </div>
                      </template>
                    </div>
                    <div class="center aligned column">
                      <div class="ui zw statistic">
                        <h1 class="zw compact header"
                            v-if="booking.selectedStartTime && booking.selectedEndTime">
                          {{
                            formatDate(booking.selectedDate + ' ' +
                              booking.selectedStartTime, 'HH:mm')
                          }} - {{
                            formatDate(booking.selectedDate + ' ' + booking.selectedEndTime,
                              'HH:mm')
                          }}
                        </h1>
                        <h1 v-else class="zw compact header">
                          {{
                            $t('modals.newbookingmodal.confirm.content.validation.no_time_picked')
                          }}
                        </h1>
                        <div class="orange label"
                             v-if="booking.selectedStartTime && booking.selectedEndTime">
                          {{ $t('modals.newbookingmodal.confirm.content.time') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui center aligned segment">
                <div class="ui zw statistic">
                  <h1 class="zw compact header" v-if="booking.selectedDate">
                    {{ formatDate(booking.selectedDate, 'YYYY') }}
                  </h1>
                  <h1 class="header" v-else>
                    {{ $t('modals.newbookingmodal.confirm.content.validation.no_year_picked') }}
                  </h1>
                </div>
              </div>
              <template v-if="update">
                <div class="ui center aligned segment">
                  <div class="ui header"
                       v-if="requiresPayment">
                    <div class="product-block">
                      <div class="product-price">
                        <div class="name">{{ safeObjectGet(updateBooking, 'booking.product.name') }}:</div>
                        <div class="price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                          {{ totalProductPrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>
                          {{ totalProductPrice | money }}
                        </div>
                      </div>
                      <div class="product-price" v-if="totalBookedFeePrice > 0">
                        <div class="name">Booked FEE:</div>
                        <div class="price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                          {{ totalBookedFeePrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>
                          {{ totalBookedFeePrice | money }}
                        </div>
                      </div>
                      <div class="product-price" v-if="hasGuest">
                        <div class="name">{{ $t('modals.newbookingmodal.guest.price') }}:</div>
                        <div class="price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                          {{ guestAdditionalPrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>{{ guestAdditionalPrice | money }}</div>
                      </div>
                      <div class="product-vat-price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                        <div class="name">25,00% moms:</div>
                        <div class="price">{{ vatPrice | money }}</div>
                      </div>
                    </div>
                    Total: {{ totalPrice | money }}
                  </div>
                  <div class="ui header" v-else>
                    {{ $t('pages.bookings.reserved_bookings.labels.free') }}
                  </div>
                </div>
                <div class="ui center aligned segment"
                     v-if="safeObjectGet(updateBooking, 'startup_fee') === 'requested' || safeObjectGet(updateBooking, 'startup_fee') === 'completed'">
                  <div class="ui header">
                    <div class="product-block">
                      <div class="product-price">
                        <div class="name">Startup Fee:</div>
                        <div class="price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                          {{ safeObjectGet(updateBooking, 'booking.product.fee_amount') * 0.8 | money }}
                        </div>
                        <div class="price" v-else>
                          {{ safeObjectGet(updateBooking, 'booking.product.fee_amount') | money }}
                        </div>
                      </div>
                      <div class="product-vat-price" v-if="safeObjectGet(updateBooking, 'booking.product.apply_vat')">
                        <div class="name">25,00% moms:</div>
                        <div class="price">{{
                            (safeObjectGet(updateBooking, 'booking.product.fee_amount') - safeObjectGet(updateBooking, 'booking.product.fee_amount') * 0.8) | money
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="ui center aligned segment">
                  <div class="ui header"
                       v-if="requiresPayment">
                    <div class="product-block">
                      <div class="product-price">
                        <div class="name">{{ safeObjectGet(selectedBooking, 'product.name') }}:</div>
                        <div class="price" v-if="safeObjectGet(selectedBooking, 'product.apply_vat')">
                          {{ totalProductPrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>
                          {{ totalProductPrice | money }}
                        </div>
                      </div>
                      <div class="product-price" v-if="totalBookedFeePrice > 0">
                        <div class="name">Booked FEE:</div>
                        <div class="price" v-if="safeObjectGet(selectedBooking, 'product.apply_vat')">
                          {{ totalBookedFeePrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>
                          {{ totalBookedFeePrice | money }}
                        </div>
                      </div>
                      <div class="product-price" v-if="hasGuest">
                        <div class="name">{{ $t('modals.newbookingmodal.guest.price') }}:</div>
                        <div class="price" v-if="safeObjectGet(selectedBooking, 'product.apply_vat')">
                          {{ guestAdditionalPrice * 0.8 | money }}
                        </div>
                        <div class="price" v-else>{{ guestAdditionalPrice | money }}</div>
                      </div>
                      <div class="product-vat-price" v-if="safeObjectGet(selectedBooking, 'product.apply_vat')">
                        <div class="name">25,00% moms:</div>
                        <div class="price">{{ vatPrice | money }}</div>
                      </div>
                    </div>
                    Total: {{ totalPrice | money }}
                  </div>
                  <div class="ui header" v-else>
                    {{ $t('pages.bookings.reserved_bookings.labels.free') }}
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="two wide tablet four wide computer column"></div>
        </div>
        <div class="ui grid" v-if="booking.selectedStartTime !== null && booking.selectedEndTime !== null">
          <span class="ui header">{{ $t('modals.booking.booking_time_notice') }}</span>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'payment_method'">
      <div class="content">
        <h3 class="ui header">{{ $t('modals.newsubscriptionmodal.payment_method.description') }}</h3>
        <p v-if="isDefaultPaymentMethod && paymentMethods.length > 0" class="text-info text-danger">
          * {{ $t('modals.newsubscriptionmodal.payment_method.default_payment_method') }}
        </p>
        <div class="ui divider"></div>
        <div class="ui zw two flex-center stackable cards">
          <template v-if="paymentMethods.length > 0">
            <payment-method v-for="paymentMethod in paymentMethods" :key="paymentMethod.id" :id="paymentMethod.id"
                            :name="paymentMethod.name" :slug="paymentMethod.slug" @select="selectPaymentMethod"
                            @deselect="deselectPaymentMethod" :active="selectedPaymentMethod === paymentMethod.slug"
                            :editable="!isDefaultPaymentMethod" :payment-plan="'instant'"/>
          </template>
          <template v-else>
            <b class="text-center" style="font-size: 20px; margin: 20px 0;">{{
                $t('globals.validation.warning.not_all_steps_completed', {0: $t('globals.container.booked')})
              }}</b>
          </template>
        </div>
        <div
          v-if="requiresPayment || safeObjectGet(updateBooking, 'startup_fee') === 'requested'">
          <div class="ui divider notice" v-if="selectedPaymentMethod === 'nets'">
            {{ $t('modals.nets_notice') }}
          </div>
          <div class="ui divider notice" v-if="selectedPaymentMethod === 'vipps'">
            {{ $t('modals.booking.vipps_notice') }}
          </div>
        </div>
      </div>
    </div>

    <div class="actions" style="margin-bottom: 1rem;">
      <div class="ui red button" @click="closeModal()">
        {{ $t('globals.buttons.cancel') }}
      </div>
      <div class="ui primary prev button" @click="prevTab()" v-if="showPrevious">
        {{ $t('globals.buttons.previous') }}
      </div>
      <div class="ui primary zw next button" @click="nextTab()" v-if="showNext">
        {{ $t('globals.buttons.next') }}
      </div>
      <template v-else-if="!showNext">
        <div class="ui button green"
             @click="activateBooking()"
             v-if="update && !requiresPayment && safeObjectGet(updateBooking, 'startup_fee') !== 'requested'"
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : isActivateButtonDisabled }]"
        >
          <span>{{ $t('globals.buttons.activate') }}</span>
        </div>
        <div class="ui button green"
             @click="activateBooking()"
             v-else-if="!update && !requiresPayment"
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : isActivateButtonDisabled }]"
        >
          <span>{{ $t('globals.buttons.activate') }}</span>
        </div>
        <vipps-mobilepay-button
          v-else-if="selectedPaymentMethod === 'vipps'"
          @click="activateBooking()"
          type="button"
          brand="vipps"
          :language="getLanguage"
          variant="primary"
          rounded="false"
          verb="pay"
          :stretched="isMobile"
          branded="true"
          :disabled="isActivateButtonDisabled"
          :loading="buttonLoader"></vipps-mobilepay-button>
        <div class="ui button green" @click="activateBooking()" v-else
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : isActivateButtonDisabled }]">
          <span>{{ $t('globals.buttons.finish') }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import size from 'lodash/size'
import assign from 'lodash/assign'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import chunk from 'lodash/chunk'
import orderBy from 'lodash/orderBy'
import moment from 'moment'
import 'flatpickr/dist/flatpickr.min.css'
import MobileDetect from 'mobile-detect'
import languages from 'flatpickr/dist/l10n'
import accounting from 'accounting'

export default {
  name: 'NewBookingModal',

  props: {
    active: {
      required: true,
      default: false,
      type: Boolean
    },

    bookingid: {
      required: true,
      default: null,
      type: Number
    },

    update: {
      required: false,
      default: false,
      type: Boolean
    },

    updateBooking: {
      required: false,
      default: null,
      type: Object
    },

    selectedPlace: {type: Object, default: null}
  },

  data() {
    return {
      updateBookingForCreate: null,
      selectedBooking: null,
      pickerSelectedDate: null,
      currentSelectedDate: null,
      realSubscriptions: [],
      subscriptions: [],
      subscriptionValue: null,
      requiredSubscriptions: [],
      maxSubscriptionsSelect: 2,
      areAllSubscriptionsChosen: true,
      isSubscriptionValueValid: true,
      paymentMethods: [
        {
          id: 1,
          name: 'Nets',
          slug: 'nets'
        },
        {
          id: 2,
          name: 'Vipps/MobilePay',
          slug: 'vipps'
        }
      ],
      isDefaultPaymentMethod: false,
      selectedPaymentMethod: null,
      isTimeAvailable: true,
      availableSlots: null,
      isCheckingAvailability: false,
      hasGuest: false,

      existingWinterPlace: false,
      selectedWinterPlace: null,
      winterPlaceMeta: {},
      overwritePlace: false,
      showOverwritePlaceConfirmModal: false,

      pendingOverwritePlace: null,
      prevOverwritePlace: null,

      booking: {
        selectedStartTime: null,
        selectedEndTime: null,
        selectedDate: null,
        selectedEndDate: null,
        availableTimes: {},
        selectableTimes: [],

        flatPickr: {
          config: {
            inline: true,
            minDate: moment().format('YYYY-MM-DD'),
            enable: [
              new Date(0, 0, 0)
            ],
            locale: {
              ...languages[window.localStorage.language || navigator.language || 'da'],
              firstDayOfWeek: 1
            }
          }
        }
      },

      details: {
        formScope: 'bookingDetails',
        showTermsModal: false,
        acceptingTerms: false,

        fieldValues: []
      },

      warningMessage: {
        formScope: 'bookingWarningMessage',
        acceptingWarning: false
      },

      currentTab: 0,

      buttonLoader: false,

      tabs: [
        {
          name: null,
          icon: null,
          title: null,
          description: null
        }
      ]
    }
  },

  watch: {
    selectedPlace(newVal) {
      if (newVal && this.selectedBooking.winter_place) {
        this.selectedWinterPlace = newVal.name

        const _find = find(this.selectedBooking.product.fields, {name: 'Vinterplads'})
        if (_find) {
          this.winterPlaceMeta = {
            id: _find.id,
            value: this.selectedWinterPlace
          }
        }
      }
    },

    active() {
      this.selectedBooking = null
      this.details.fieldValues = []
      this.subscriptionValue = null
      this.selectedPaymentMethod = null
      this.details.acceptingTerms = false
      this.availableSlots = null
      this.isCheckingAvailability = false
      this.isTimeAvailable = true
      this.hasGuest = this.update ? !!this.updateBooking.has_guest : false
      if (!this.update) {
        this.booking = {
          selectedStartTime: null,
          selectedEndTime: null,
          selectedDate: null,
          selectedEndDate: null,
          availableTimes: {},
          selectableTimes: [],

          flatPickr: {
            config: {
              inline: true,
              minDate: moment().format('YYYY-MM-DD'),
              enable: [
                new Date(0, 0, 0)
              ],
              locale: {
                ...languages[window.localStorage.language || navigator.language || 'da'],
                firstDayOfWeek: 1
              }
            }
          }
        }
      }
      this.flatPickr = {
        config: {
          inline: true,
          minDate: moment().format('YYYY-MM-DD'),
          enable: [
            new Date(0, 0, 0)
          ],
          locale: {
            ...languages[window.localStorage.language || navigator.language || 'da'],
            firstDayOfWeek: 1
          }
        }
      }
      this.fetchBooking(this.bookingid)
        .then(booking => {
          this.selectedBooking = booking.data
          this.isDefaultPaymentMethod = booking.data.product.payment_method !== null

          if (this.isDefaultPaymentMethod) {
            this.selectedPaymentMethod = this.isDefaultPaymentMethod ? booking.data.product.payment_method : null
            this.filterPaymentMethods()
          }

          if (this.update && this.selectedBooking.winter_place) {
            const _findField = find(this.selectedBooking.product.fields, {name: 'Vinterplads'})
            if (_findField) {
              const _findWinterPlace = find(this.updateBooking.metas, {field_id: _findField.id})

              if (_findWinterPlace) {
                this.selectedWinterPlace = _findWinterPlace.value
                this.winterPlaceMeta = {
                  id: _findField.id,
                  value: this.selectedWinterPlace
                }
              }
            }
          }

          this.loadTabs()
            .then(() => {
              $(this.$el).modal('refresh').modal('show')

              this.reloadSize()
            })

          this.fetchSubscriptions()

          if (!this.update && this.selectedBooking.winter_place) {
            this.fetchWinterPlace()
          }
        })
    },

    subscriptionValue(val) {
      if (val) {
        const split = val.split(',')

        if (this.requiredSubscriptions.length > 0) {
          const _this = this
          let isValid = true

          let selectedSubscriptions = split.map(function (val) {
            return _this.subscriptions[val]
          })

          if (this.requiredSubscriptions.length > 1) {
            isValid = selectedSubscriptions.every(v => this.requiredSubscriptions.includes(v));
          } else {
            isValid = selectedSubscriptions.some(v => this.requiredSubscriptions.includes(v));
          }

          if (!isValid) {
            this.isSubscriptionValueValid = false
          } else {
            this.isSubscriptionValueValid = !(split.length > 0 && split.length < this.maxSubscriptionsSelect && split.length < this.requiredSubscriptions.length);
          }
        }

        this.areAllSubscriptionsChosen = !(this.selectedBooking.amount_of_required_subscriptions !== null && split.length < this.selectedBooking.amount_of_required_subscriptions);
      } else {
        this.isSubscriptionValueValid = true
        this.areAllSubscriptionsChosen = true
      }
    }
  },

  mounted() {
    moment.locale(window.localStorage.language || navigator.language || 'da')

    const _this = this
    // initialize modal
    this.$nextTick(function () {
      $(this.$el).modal({
        observeChanges: true,
        detachable: true,
        closable: true,
        transition: 'fade',

        dimmerSettings: {
          closable: false,
          closeable: false,
          useCSS: true
        },

        onVisible: function () {
          $(_this.$el).modal('refresh')
        },

        onClose: function () {
          // Emit to parent that modal was closed
          _this.$emit('onClose')
        }
      })
    })

    if (this.update) {
      this.hasGuest = !!this.updateBooking.has_guest
      this.selectedPaymentMethod = this.updateBooking.payment_method
      this.booking.selectedStartTime = this.updateBooking.start_time.split(' ')[1]
      this.booking.selectedEndTime = this.updateBooking.end_time.split(' ')[1]
      this.booking.selectedDate = this.updateBooking.start_time.split(' ')[0]
      this.booking.selectedEndDate = this.updateBooking.end_time.split(' ')[0]
    }

    this.fetchSubscriptions()
  },

  computed: {
    isMobile() {
      return window.innerWidth < 451;
    },
    getLanguage() {
      if (this.$root.$i18n.locale) {
        return this.$root.$i18n.locale
      } else {
        if (window.localStorage.language) {
          return window.localStorage.language
        } else if (navigator.language) {
          return navigator.language
        } else {
          return 'da'
        }
      }
    },

    isActivateButtonDisabled() {
      let isPaymentMethodSelected = true
      if (this.$store.getters.activeMerchant.vipps) {
        if (this.update) {
          if (this.requiresPayment) {
            if (!this.selectedPaymentMethod) {
              isPaymentMethodSelected = false
            }
          }
        } else {
          if (this.requiresPayment) {
            if (!this.selectedPaymentMethod) {
              isPaymentMethodSelected = false
            }
          }
        }
      }

      return !isPaymentMethodSelected || !this.booking.selectedDate || !this.booking.selectedStartTime || !this.booking.selectedEndTime || !this.isTimeAvailable || this.isCheckingAvailability || this.buttonLoader
    },

    totalPrice() {
      const bookedFeePrice = this.totalBookedFeePrice
      let totalPrice = this.totalProductPrice + this.guestAdditionalPrice

      if (bookedFeePrice > 0) {
        totalPrice += bookedFeePrice
      }

      return totalPrice
    },

    memberBookingIsFree() {
      return this.update
        ? !!this.safeObjectGet(this.updateBooking, 'is_free')
        : !!this.safeObjectGet(this.selectedBooking, 'hasFreeBooked')
    },

    requiresPayment() {
      return this.totalPrice > 0
    },

    isGuestOptionLocked() {
      return this.update && !['unset', 'rejected'].includes(this.safeObjectGet(this.updateBooking, 'status'))
    },

    guestCapacityUnavailable() {
      return !!this.selectedBooking.multiple && this.availableSlots !== null && this.availableSlots < 2
    },

    canEditGuest() {
      return !this.isGuestOptionLocked && !this.isCheckingAvailability &&
        (!this.guestCapacityUnavailable || this.hasGuest)
    },

    guestAdditionalPrice() {
      return this.hasGuest ? this.guestOptionPrice : 0
    },

    guestProductPrice() {
      return +this.safeObjectGet(this.selectedBooking, 'product.pricing.0.price')
    },

    guestOptionPrice() {
      return this.guestProductPrice + this.configuredGuestFee
    },

    configuredGuestFee() {
      return this.update && this.safeObjectGet(this.updateBooking, 'has_guest')
        ? +this.safeObjectGet(this.updateBooking, 'guest_fee')
        : +this.safeObjectGet(this.selectedBooking, 'guest_fee')
    },

    totalProductPrice() {
      return this.memberBookingIsFree ? 0 : +this.safeObjectGet(this.selectedBooking, 'product.pricing.0.price')
    },

    totalBookedFeePrice() {
      let bookedFee = 0
      if (this.subscriptionValue) {
        if (`${this.subscriptionValue}`.indexOf(',') !== -1) {
          const split = `${this.subscriptionValue}`.split(',')
          const additionalPrice = split.reduce((prev, next) => {
            const price = this.safeObjectGet(this.realSubscriptions[next], 'product.category.booked_fee')
            if (price) {
              return prev + price
            }
            return prev
          }, 0)

          if (additionalPrice) {
            bookedFee += +additionalPrice
          }
        }
        const price = this.safeObjectGet(this.realSubscriptions[this.subscriptionValue], 'product.category.booked_fee')

        if (price) {
          bookedFee += +price
        }
      }
      return this.memberBookingIsFree ? 0 : bookedFee
    },

    vatPrice() {
      return this.totalPrice - (this.totalPrice * 0.8)
    },

    showNext() {
      return this.currentTab !== this.tabs.length - 1
    },

    subscriptionField() {
      return {
        type: 'select',
        name: this.$t('modals.newbookingmodal.select_active_subscription'),
        options: this.subscriptions,
        required: true,
        editable: 1,
        meta: {
          value: this.subscriptionValue
        }
      }
    },

    showPrevious() {
      return this.currentTab !== 0
    }
  },

  methods: {
    filterPaymentMethods() {
      const _this = this

      this.paymentMethods = this.paymentMethods.filter(function (currentValue, index) {
        if (currentValue.slug === _this.selectedPaymentMethod) {
          return currentValue
        }
      })
    },

    chunkProperty(chunkedProperty, value) {
      return chunk(chunkedProperty, value)
    },

    getPaymentMethodName(method) {
      let chosenMethod = ''

      this.paymentMethods.filter((elem) => {
        if (elem.slug === method) {
          chosenMethod = elem.name
        }
      })

      return chosenMethod
    },

    formatPrice(amount, minfrac = 2) {
      if (amount !== null) {
        return accounting.formatMoney(amount, 'DKK ', minfrac)
      }
    },

    loadTabs() {
      return new Promise((resolve, reject) => {
        this.tabs = []
        this.currentTab = 0

        this.tabs.push(
          {
            name: 'product',
            icon: 'cube',
            title: this.$t('modals.newbookingmodal.product.title'),
            description: this.$t('modals.newbookingmodal.product.description'),
            order: 1
          },
          {
            name: 'details',
            icon: 'info',
            title: this.$t('modals.newbookingmodal.details.title'),
            description: this.$t('modals.newbookingmodal.details.description'),
            order: 3
          },
          {
            name: 'confirm',
            icon: 'send',
            title: this.$t('modals.newbookingmodal.confirm.title'),
            description: this.$t('modals.newbookingmodal.confirm.description'),
            order: 5
          }
        )

        let loadWarningMessageTab = false

        if (this.safeObjectGet(this.selectedBooking, 'warning_message')) {
          loadWarningMessageTab = true
        }

        if (loadWarningMessageTab) {
          this.tabs.push({
            name: 'warning_message',
            icon: 'warning',
            title: this.$t('modals.newbookingmodal.warning_message.title'),
            description: this.$t('modals.newbookingmodal.warning_message.description'),
            order: 4
          })
        }

        if (this.$store.getters.activeMerchant.vipps) {
          let loadPaymentTab = true
          if (this.update) {
            if (!this.requiresPayment && this.safeObjectGet(this.updateBooking, 'startup_fee') !== 'requested') {
              loadPaymentTab = false
            }
          } else {
            if (!this.requiresPayment) {
              loadPaymentTab = false
            }
          }

          if (loadPaymentTab) {
            this.tabs.push({
              name: 'payment_method',
              icon: 'money',
              title: this.$t('modals.newsubscriptionmodal.payment_method.title'),
              description: this.$t('modals.newsubscriptionmodal.payment_method.description'),
              order: 6
            })
          }
        }

        if (!this.update) {
          this.tabs.push({
            name: 'time',
            icon: 'calendar',
            title: this.$t('modals.newbookingmodal.time.title'),
            description: this.$t('modals.newbookingmodal.time.description'),
            order: 2
          })
        }

        if (this.$store.getters.activeMerchant.winter_place &&
          this.safeObjectGet(this.selectedBooking, 'winter_place') &&
          this.safeObjectGet(this.selectedBooking, 'showMarinaPicture')
        ) {
          this.tabs.push({
            name: 'winter_place',
            icon: 'table',
            title: this.$t('modals.newbookingmodal.winter_place.title'),
            description: this.$t('modals.newbookingmodal.winter_place.description'),
            order: 2
          })
        }

        this.tabs = orderBy(this.tabs, ['order'], ['asc'])

        this.$nextTick(() => resolve())
      })
    },

    switchTab(index) {
      this.currentTab = index
      this.reloadSize()
    },

    reloadSize() {
      this.$nextTick(() => {
        this.checkIfIE().then().catch(() => {
          var event = document.createEvent('HTMLEvents')
          event.initEvent('resize', true, false)
          window.dispatchEvent(event)
        })

        $(this.$el).modal('refresh')
      })
    },

    fetchBooking(bookingId) {
      return new Promise((resolve, reject) => {
        this.axios.get(`bookings/${bookingId}`)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    closeModal() {
      $(this.$el).modal('hide')
      this.$nextTick(() => this.$emit('onClose'))
    },

    nextTab() {
      const nextTab = this.currentTab + 1
      if (size(this.tabs[nextTab]) > 0) {
        this.switchTab(nextTab)
      }
    },

    prevTab() {
      const prevTab = this.currentTab - 1
      if (size(this.tabs[prevTab]) > 0) {
        this.switchTab(prevTab)
      }
    },

    tabExists(tabName) {
      return !!find(this.tabs, {name: tabName})
    },

    selectPaymentMethod(slug) {
      this.selectedPaymentMethod = slug
    },

    deselectPaymentMethod() {
      this.selectedPaymentMethod = null
    },

    // Date fetching function
    fetchDates(timeString, time, config) {
      // Format month fetched
      const month = (config.currentMonth + 1 < 10) ? `0${config.currentMonth + 1}` : config.currentMonth + 1
      const current = moment()
      const today = moment(`${config.currentYear}-${month}-01`)
      const startDate = current.isSame(today, 'month') ? current : moment(`${config.currentYear}-${month}-01`)
      const endDate = moment(`${config.currentYear}-${month}-01`).add(2, 'month').date(0)

      this.axios.get(`bookings/${this.bookingid}/times`, {
        params: {
          startTime: startDate.format('YYYY-MM-DD'),
          endTime: endDate.format('YYYY-MM-DD')
        }
      })
        .then(({data}) => {
          if (size(data.data.intervals) > 0) {
            assign(this.booking.availableTimes, data.data.intervals)

            this.$set(this.booking.flatPickr.config, 'enable', Object.keys(this.booking.availableTimes))

            this.$nextTick(() => {
              this.$refs.flatpicker.fp.jumpToDate(today.format('YYYY-MM-DD'))
              this.fetchTimes(0, this.booking.selectedDate)
            })
          }
        })
    },

    fetchTimes(timeString, time, config) {
      // Fetch available times based on date selected
      this.booking.selectableTimes = (this.booking.availableTimes[time] ? orderBy(this.booking.availableTimes[time], ['startTime'], ['asc']) : [])

      if (!find(this.booking.selectableTimes, {
        endTime: this.booking.selectedEndTime,
        startTime: this.booking.selectedStartTime
      }) || this.selectedBooking.multiple) {
        this.booking.selectedStartTime = null
        this.booking.selectedEndTime = null
        this.isTimeAvailable = true
        this.availableSlots = null
      }
    },

    selectTime(startTime, endTime) {
      // Check date maybe
      if (this.booking.selectedStartTime === startTime && this.booking.selectedEndTime === endTime) {
        this.booking.selectedStartTime = null
        this.booking.selectedEndTime = null
      } else {
        this.booking.selectedStartTime = startTime
        this.booking.selectedEndTime = endTime
      }

      this.checkTimeAvailability()
    },

    checkTimeAvailability() {
      if (!this.selectedBooking.multiple || !this.booking.selectedStartTime || !this.booking.selectedEndTime) {
        this.availableSlots = null
        this.isCheckingAvailability = false
        this.isTimeAvailable = true
        return
      }

      this.availableSlots = null
      this.isCheckingAvailability = true

      this.axios.get(`bookings/${this.bookingid}/amount`, {
        params: {
          startTime: this.booking.selectedStartTime,
          endTime: this.booking.selectedEndTime,
          date: this.booking.selectedDate
        }
      }).then(({data}) => {
        const requestedPlaces = this.hasGuest ? 2 : 1
        this.availableSlots = this.selectedBooking.amount - data
        this.isTimeAvailable = this.availableSlots >= requestedPlaces
      }).catch(() => {
        this.isTimeAvailable = false
      }).finally(() => {
        this.isCheckingAvailability = false
      })
    },

    formatDate(date, format = 'YYYY-MM-DD') {
      return moment(date).format(format)
    },

    capitalize(input) {
      return input.toUpperCase()
    },

    checkIfIE() {
      return new Promise((resolve, reject) => {
        var md = new MobileDetect(navigator.userAgent)
        if (md.versionStr('IE')) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },

    // Details methods
    changeTermsValue() {
      this.details.acceptingTerms = !this.details.acceptingTerms
    },

    changeGuestValue(event) {
      const enableGuest = event.target.checked

      if (enableGuest) {
        const message = this.$t('modals.newbookingmodal.guest.confirmation', {
          amount: this.formatPrice(this.guestOptionPrice)
        })

        if (!window.confirm(message)) {
          event.target.checked = false
          return
        }
      }

      this.hasGuest = enableGuest
      this.checkTimeAvailability()
    },

    changeWarningAcceptValue() {
      this.warningMessage.acceptingWarning = !this.warningMessage.acceptingWarning
    },

    syncCheckbox() {
      this.$nextTick(() => {
        if (this.$refs.overwriteCheckbox) {
          this.$refs.overwriteCheckbox.checked = this.overwritePlace;
        }
      });
    },

    handleCheckboxClick(e) {
      const isAttemptingToUncheck = this.overwritePlace === true;
      const hasExisting = !!this.existingWinterPlace;
      const selectionDiffers = this.selectedWinterPlace !== this.existingWinterPlace;

      if (isAttemptingToUncheck && hasExisting && selectionDiffers) {
        e.preventDefault();

        this.prevSelectedWinterPlace = this.selectedWinterPlace;
        this.showOverwritePlaceConfirmModal = true;
        return;
      }
    },

    acceptOverwritePlace() {
      this.overwritePlace = false;
      this.selectedWinterPlace = this.existingWinterPlace;

      this.showOverwritePlaceConfirmModal = false;
      this.prevSelectedWinterPlace = null;
    },

    denyOverwritePlace() {
      if (this.prevSelectedWinterPlace !== null) {
        this.selectedWinterPlace = this.prevSelectedWinterPlace;
      }

      this.showOverwritePlaceConfirmModal = false;
      this.prevSelectedWinterPlace = null;
    },

    acceptTerms() {
      this.details.acceptingTerms = true
      $(this.$el).modal('show')
    },

    denyTerms() {
      this.details.acceptingTerms = false
      $(this.$el).modal('show')
    },

    changeFieldValue(field) {
      if (!find(this.details.fieldValues, {id: field.id})) {
        this.details.fieldValues.push(field)
      } else {
        var arrayValue = find(this.details.fieldValues, {id: field.id})
        arrayValue.value = field.value
      }
    },

    // Booking activation methods
    validateFields(scope) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll(scope)
          .then(result => {
            if (result) {
              if (!this.isSubscriptionValueValid || !this.areAllSubscriptionsChosen) {
                this.$events.$emit('alert', {
                  header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
                  message: this.$t('modals.newbookingmodal.validation.errors.fill_out_missing'),
                  type: 'error',
                  closebutton: true,
                  align: 'right'
                })

                this.currentTab = findIndex(this.tabs, {name: 'details'})
                this.reloadSize()

                reject()
              } else {
                resolve()
              }
            } else {
              this.$events.$emit('alert', {
                header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
                message: this.$t('modals.newbookingmodal.validation.errors.fill_out_missing'),
                type: 'error',
                closebutton: true,
                align: 'right'
              })

              this.currentTab = findIndex(this.tabs, {name: 'details'})
              this.reloadSize()

              reject()
            }
          })
      })
    },

    activateSubscription(bookedID) {
      return new Promise((resolve, reject) => {
        this.axios.put(`/booked/${bookedID}/activate`)
          .then((response) => {
            $(this.$el).modal('toggle')

            if (response.data.data.is_free && !response.data.data.has_guest) {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: this.$t('pages.bookings.validation.success.booking_added_free'),
                type: 'success',
                align: 'right'
              })
            } else {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: this.$t('pages.bookings.validation.success.booking_added_paid', {payment_time: moment(response.data.data.payment_time).format('YYYY-MM-DD HH:mm:ss')}),
                type: 'success',
                align: 'right'
              })
            }

            this.$events.$emit('booking-reserved', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    createVippsMobilePayPayment(bookedId, startUpFee = false) {
      let url = ''

      if (startUpFee) {
        url = `booked/${bookedId}/startup-fee/payment`
      } else {
        url = `booked/${bookedId}/createPayment`
      }

      this.axios.post(url).then((response) => {
        if (response.status === 204) {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: 'Activating...',
            type: 'success',
            align: 'right'
          })

          this.activateSubscription(bookedId)
        } else {
          $(this.$el).modal('toggle')

          window.location.href = response.data.url
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.data.message) {
            let messageText = this.$t('globals.validation.errors.try_again_later')

            try {
              const errorDescription = JSON.parse(error.response.data.message)

              if (errorDescription.hasOwnProperty('error_description')) {
                messageText = errorDescription.error_description.message
              } else if (errorDescription.hasOwnProperty('message')) {
                messageText = errorDescription.message
              }
            } catch (e) {
              // Backend can return plain text for some 4xx errors (e.g. duplicate authorized payment)
              messageText = error.response.data.message
            }

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: messageText,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }
      })
    },

    activateBooking() {
      this.buttonLoader = true

      this.validateFields(this.details.formScope)
        .then(() => {
          if (this.details.acceptingTerms === true) {
            if (this.isSubscriptionValueValid && this.areAllSubscriptionsChosen) {
              if (this.warningMessage.acceptingWarning === true || !this.selectedBooking.warning_message) {
                if ((this.selectedBooking.multiple && this.isTimeAvailable) || !this.selectedBooking.multiple) {
                  const constructFields = []
                  let constructRequest = {
                    booking_id: this.selectedBooking.id,
                    has_guest: this.hasGuest
                  }

                  if (!this.update) {
                    if (this.booking.selectedStartTime === this.booking.selectedEndTime) {
                      const nextDay = moment(this.booking.selectedDate).add(1, 'day').format('YYYY-MM-DD')
                      constructRequest.start_time = this.booking.selectedDate + ' ' + this.booking.selectedStartTime
                      constructRequest.end_time = nextDay + ' ' + this.booking.selectedEndTime
                    } else {
                      constructRequest.start_time = this.booking.selectedDate + ' ' + this.booking.selectedStartTime
                      constructRequest.end_time = this.booking.selectedDate + ' ' + this.booking.selectedEndTime
                    }

                    if (this.selectedBooking.winter_place) {
                      if (this.overwritePlace) {
                        constructRequest.overwrite_winter_place = true
                      } else {
                        constructRequest.overwrite_winter_place = false
                      }
                    }
                  }

                  if (this.details.fieldValues.length > 0) {
                    this.details.fieldValues.map(currentValue => {
                      constructFields.push(
                        {
                          id: currentValue.id,
                          value: currentValue.value
                        }
                      )
                    })

                    constructRequest.fields = constructFields
                  }

                  if (this.subscriptionValue) {
                    if (this.subscriptionValue.indexOf(',') === -1) {
                      constructRequest.subscription_ids = [this.realSubscriptions[this.subscriptionValue].id]
                    } else {
                      constructRequest.subscription_ids = this.subscriptionValue.split(',').map(i => this.realSubscriptions[i].id)
                    }
                  }

                  if (this.selectedPaymentMethod) {
                    constructRequest.payment_method = this.selectedPaymentMethod
                  } else {
                    if (this.requiresPayment) {
                      this.selectedPaymentMethod = 'nets'
                      constructRequest.payment_method = this.selectedPaymentMethod
                    }
                  }

                  if (Object.keys(this.winterPlaceMeta).length > 0) {
                    constructRequest.winter_place = this.winterPlaceMeta
                  }

                  this.axios({
                    method: this.update ? 'put' : 'post',
                    url: this.update ? `booked/${this.updateBooking.id}` : `booked`,
                    data: constructRequest
                  })
                    .then(({data}) => {
                      if (!this.update) {
                        this.$events.$emit('alert', {
                          header: this.$t('modals.newbookingmodal.validation.success.booking_reserved'),
                          message: this.$t('modals.newbookingmodal.validation.success.booking_reserved2'),
                          type: 'success',
                          closebutton: true,
                          align: 'right'
                        })

                        this.$events.$emit('booking-reserved', data)
                        this.buttonLoader = false
                        if (this.requiresPayment) {
                          this.updateBookingForCreate = data.data
                          if (this.selectedPaymentMethod === 'vipps') {
                            this.createVippsMobilePayPayment(data.data.id)
                          } else {
                            this.closeModal()
                            this.$router.push({
                              name: 'checkout',
                              params: {containerId: data.data.id},
                              query: {container: 'booked'}
                            })
                          }
                        } else {
                          this.closeModal()
                        }
                      } else {
                        this.$events.$emit('booking-reserved', data)
                        this.buttonLoader = false

                        if (this.selectedPaymentMethod === 'vipps') {
                          if (this.safeObjectGet(this.updateBooking, 'startup_fee') === 'requested') {
                            this.createVippsMobilePayPayment(data.data.id, true)
                          } else if (this.requiresPayment) {
                            this.createVippsMobilePayPayment(data.data.id)
                          } else {
                            if (data.data.status === 'unset') {
                              this.activateSubscription(data.data.id).then(() => {
                                this.closeModal()
                              }).catch()
                            } else {
                              this.closeModal()
                            }
                          }
                        } else {
                          if (this.requiresPayment) {
                            this.closeModal()
                            this.$router.push({
                              name: 'checkout',
                              params: {containerId: data.data.id},
                              query: {container: 'booked'}
                            })
                          } else {
                            if (this.safeObjectGet(this.updateBooking, 'startup_fee') === 'requested') {
                              this.closeModal()
                              this.$router.push({name: 'checkout_startup_fee', params: {id: data.data.id}})
                            } else {
                              if (data.data.status === 'unset') {
                                this.activateSubscription(data.data.id).then(() => {
                                  this.closeModal()
                                }).catch()
                              } else {
                                this.closeModal()
                              }
                            }
                          }
                        }
                      }
                    }).catch(error => {
                    this.buttonLoader = false

                    if (error.response) {
                      const responseData = error.response.data;

                      if (responseData && responseData.errors && responseData.errors[0]) {
                        this.$events.$emit('alert', {
                          header: this.$t('globals.validation.errors.something_went_wrong'),
                          message: responseData.errors[0],
                          type: 'error',
                          align: 'right'
                        })
                      }
                    } else {
                      this.$events.$emit('alert', {
                        header: this.$t('globals.validation.errors.something_went_wrong'),
                        message: this.$t('globals.validation.errors.contact_merchant'),
                        type: 'error',
                        align: 'right'
                      })
                    }
                  })
                } else {
                  this.$events.$emit('alert', {
                    header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
                    message: this.$t('modals.newbookingmodal.validation.errors.no_available_time'),
                    type: 'error',
                    closebutton: true,
                    align: 'right'
                  })

                  this.buttonLoader = false
                  this.currentTab = findIndex(this.tabs, {name: 'time'})
                  this.reloadSize()
                }
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
                  message: this.$t('modals.newsubscriptionmodal.validation.errors.not_accepting_warning_message'),
                  type: 'error',
                  closebutton: true,
                  align: 'right'
                })

                this.buttonLoader = false
                this.currentTab = findIndex(this.tabs, {name: 'warning_message'})
                this.reloadSize()
              }
            } else {
              this.$events.$emit('alert', {
                header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
                message: this.$t('modals.newsubscriptionmodal.validation.errors.subscription_field_incorrect'),
                type: 'error',
                closebutton: true,
                align: 'right'
              })

              this.buttonLoader = false
              this.currentTab = findIndex(this.tabs, {name: 'details'})
              this.reloadSize()
            }
          } else {
            this.$events.$emit('alert', {
              header: this.$t('modals.newbookingmodal.validation.errors.something_is_missing'),
              message: this.$t('modals.newsubscriptionmodal.validation.errors.not_accepting_terms'),
              type: 'error',
              closebutton: true,
              align: 'right'
            })

            this.buttonLoader = false
            this.currentTab = findIndex(this.tabs, {name: 'details'})
            this.reloadSize()
          }
        }).catch(() => {
        this.buttonLoader = false
      })
    },
    fetchSubscriptions() {
      const merchantId = this.safeObjectGet(this.$store.state, 'merchant.activeMerchant.id')
      return new Promise((resolve, reject) => {
        if (merchantId) {
          this.axios.get(`merchants/${merchantId}/subscriptions`, {
            params: {
              page: 0,
              filter: 'active|delayed',
              perPage: 0
            }
          })
            .then(({data}) => {
              this.realSubscriptions = data.data
              this.subscriptions = data.data.map(i => i.product.required_for_booking ? '* ' + i.product.name : i.product.name)

              let requiredSub = []
              data.data.map((sub) => {
                if (sub.product.required_for_booking) {
                  requiredSub.push('* ' + sub.product.name)
                }
              })
              this.requiredSubscriptions = requiredSub

              if (this.updateBooking && this.updateBooking.subscriptions && this.updateBooking.subscriptions.length) {
                this.subscriptionValue = this.updateBooking.subscriptions.map(s => {
                  return this.realSubscriptions.findIndex(r => r.id === s.id)
                }).filter(n => n !== -1).join(',') || null
              } else {
                this.subscriptionValue = null
              }
              resolve(data)
            }, error => {
              reject(error)
            })
        } else {
          reject('Missing Merchant ID')
        }
      })
    },
    changeSubscription(v) {
      this.subscriptionValue = v
    },
    fetchWinterPlace() {
      const merchantId = this.safeObjectGet(this.$store.state, 'merchant.activeMerchant.id')
      return new Promise((resolve, reject) => {
        if (merchantId) {
          this.axios.get(`merchants/${merchantId}/users/${this.$auth.user().id}/winter-place`)
            .then(({data}) => {
              if (data.winter_place) {
                this.existingWinterPlace = data.winter_place
                this.selectedWinterPlace = this.existingWinterPlace

                const _find = find(this.selectedBooking.product.fields, {name: 'Vinterplads'})
                if (_find) {
                  this.winterPlaceMeta = {
                    id: _find.id,
                    value: this.existingWinterPlace
                  }
                }
              }
              resolve(data)
            }, error => {
              reject(error)
            })
        } else {
          reject('Missing Merchant ID')
        }
      })
    }
  }
}
</script>

<style scoped>
.product-block {
  display: block;
  padding: 10px 20px;
  width: 100%;
}

.product-price, .product-vat-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.notice {
  padding-top: 20px;
  color: red !important;
  text-transform: none;
}

.text-danger {
  color: red;
}

.guest-option {
  padding: 1.25rem;
  border: 1px solid #d9e0e7;
  border-radius: 6px;
  background: #f8fafc;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 20px;
}

.guest-option--selected {
  border-color: #2185d0;
  background: #f4faff;
  box-shadow: inset 4px 0 0 #2185d0;
}

.guest-option--locked {
  background: #f5f5f5;
}

.guest-option--unavailable {
  border-color: #e0b44c;
  background: #fffaf3;
}

.guest-option__content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.guest-option__icon {
  display: flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: #2185d0;
  background: #e6f3fc;
}

.guest-option__icon .icon {
  margin: 0;
}

.guest-option__details {
  flex: 1;
  min-width: 0;
}

.guest-option__title {
  margin-bottom: 0.25rem;
  font-size: 1.05rem;
  font-weight: 700;
}

.guest-option__details p {
  margin: 0 0 0.5rem;
  color: #5f6b76;
}

.guest-option__price {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  color: #1b1c1d;
}

.guest-option__price > span {
  white-space: nowrap;
}

.guest-option__price-total {
  color: #2185d0;
}

.guest-option__checkbox {
  flex: 0 0 auto;
}

.guest-option__locked-message,
.guest-option__capacity-message {
  margin: 1rem 0 0;
  padding-top: 0.75rem;
  border-top: 1px solid #d9e0e7;
}

.guest-option__locked-message {
  color: #9f3a38;
}

.guest-option__capacity-message {
  color: #8a6116;
}

@media only screen and (max-width: 768px) {
  .notice {
    padding-bottom: 20px;
  }

  .guest-option__content {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .guest-option__details {
    flex-basis: calc(100% - 58px);
  }

  .guest-option__checkbox {
    margin-left: 58px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/booking/NewBookingModal.vue